import SvgIcon from '@mui/material/SvgIcon';

const TimelineIcon = (props) => (
  <SvgIcon viewBox="0 0 25 24" sx={{ fill: 'none' }} {...props}>
    <g clipPath="url(#clip0_4891_7009)">
      <rect x="3.3335"  y="8"  width="11" height="2" fill="currentColor" />
      <rect x="11.3335" y="12" width="9"  height="2" fill="currentColor" />
      <rect x="5.3335"  y="12" width="4"  height="2" fill="currentColor" />
      <rect x="7.3335"  y="16" width="10" height="2" fill="currentColor" />

      <rect
        x="2.3335"
        y="4"
        width="20"
        height="17"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4891_7009">
        <rect width="24" height="24" fill="white" transform="translate(0.3335)" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default TimelineIcon;
